function locationSelect(id) {

    let select = $('#'+id);

    if ( select.length ) {
        select.select2({
            width: '100%',
            language: {
                noResults : function(){
                    return "Ничего не найдено";
                }
            }
        });

        $(document).on('click', '.select2', function(){
            var customScrollBar = new CustomScrollbar($('.select2-results'));
        });
    }

}